import { Component, Input, OnInit, signal } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { OrderProcessStatus } from '../../shared-lib/domains/order';
import { OrderService } from "../../shared/order.service";

@Component({
  selector: 'app-order-restart-dialog',
  templateUrl: './order-restart-dialog.component.html',
  styleUrls: ['./order-restart-dialog.component.scss'],
  standalone: false
})
export class OrderRestartDialogComponent implements OnInit {
  checked = false;
  unavailable = signal(false);
  @Input() order;
  private destroy$ = new Subject<void>();

  constructor(private modalController: ModalController, private orderService: OrderService) {
  }

  ngOnInit() {
    this.orderService.get$(this.order?.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(order => {
        this.unavailable.set(order.processStatus !== OrderProcessStatus.PENDING);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    this.modalController.dismiss(true);
  }
}
